import styled from "@emotion/styled";
import { Block } from "ui-kit";

export const DataContainer = styled(Block)`
  padding: 24px 40px 64px;
`;
